import React, { useEffect, useRef, useState } from "react";
import { Loader } from "@googlemaps/js-api-loader";
import {
  GOOGLE_MAPS_API_KEY,
  buildStaticRideMapUrl,
  encodePolyline,
  hasRideMapCoordinates,
  staticMapSizeForContainer,
} from "../config/rideMap";

function requestDrivingPath(item) {
  return new Promise((resolve, reject) => {
    const directionsService = new window.google.maps.DirectionsService();
    directionsService.route(
      {
        origin: {
          lat: Number(item.latitudeFrom),
          lng: Number(item.longitudeFrom),
        },
        destination: {
          lat: Number(item.latitudeTo),
          lng: Number(item.longitudeTo),
        },
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        const overviewPath = result?.routes?.[0]?.overview_path;
        if (status === "OK" && overviewPath?.length) {
          resolve(
            overviewPath.map((latLng) => ({
              lat: latLng.lat(),
              lng: latLng.lng(),
            }))
          );
          return;
        }

        reject(new Error(status || "NO_ROUTE"));
      }
    );
  });
}

async function fetchDrivingEncodedPath(item) {
  await new Loader({
    apiKey: GOOGLE_MAPS_API_KEY,
    version: "weekly",
  }).load();

  return encodePolyline(await requestDrivingPath(item));
}

function StaticRideMap({ item }) {
  const containerRef = useRef(null);
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    if (!hasRideMapCoordinates(item)) {
      setImageUrl(null);
      return;
    }

    const container = containerRef.current;
    const size = staticMapSizeForContainer(
      container?.clientWidth,
      container?.clientHeight
    );
    let cancelled = false;

    fetchDrivingEncodedPath(item)
      .then((encodedPath) => {
        if (!cancelled) {
          setImageUrl(buildStaticRideMapUrl(item, { ...size, encodedPath }));
        }
      })
      .catch(() => {
        if (!cancelled) {
          setImageUrl(buildStaticRideMapUrl(item, size));
        }
      });

    return () => {
      cancelled = true;
    };
  }, [
    item?.uuid,
    item?.latitudeFrom,
    item?.longitudeFrom,
    item?.latitudeTo,
    item?.longitudeTo,
  ]);

  if (!hasRideMapCoordinates(item)) {
    return <div className="google-map google-map--unavailable">Map unavailable</div>;
  }

  return (
    <div ref={containerRef} className="google-map google-map--static-wrap">
      {imageUrl ? (
        <img src={imageUrl} alt="Ride route from pickup to dropoff" />
      ) : (
        <div className="google-map--unavailable">Loading...</div>
      )}
    </div>
  );
}

export default StaticRideMap;
